import api from '../utils/api';

const BUSINESS_ID = parseInt(process.env.REACT_APP_BUSINESS_ID, 10);

export const login = (credentials) => {
  return api.post('/auth/login', credentials);
};

export const register = (data) => {
  return api.post('/auth/register', {
    ...data,
    business_id: BUSINESS_ID,
  });
};

export const logout = () => {
  return api.post('/auth/logout');
};

export const getUser = () => {
  return api.get('/auth/user');
};

export const forgotPassword = (data) => {
  return api.post('/auth/forgot-password', data);
};

export const resetPassword = (data) => {
  return api.post('/auth/reset-password', data);
};

export const googleAuth = (data) => {
  return api.post('/auth/google', {
    ...data,
    business_id: BUSINESS_ID,
  });
};

/* ¿Existe una cuenta con ese correo o teléfono? Anti-enumeración: solo
   devuelve { exists: boolean }. Ambos campos son opcionales. */
export const checkAccount = ({ email, phone }) => {
  return api.post('/auth/check-account', {
    email: email || undefined,
    phone: phone || undefined,
  });
};
